import adminSettings from './adminSettings.js'
import api from './api.js'
import chats from './chats.js'
import config from './config.js'
import drafts from './drafts.js'
import instance from './instance.js'
import notifications from './notifications.js'
import profileConfig from './profileConfig.js'
import statuses from './statuses.js'
import users from './users.js'

export default {
  instance,
  statuses,
  notifications,
  users,
  api,
  config,
  profileConfig,
  adminSettings,
  drafts,
  chats,
}
